import React from "react";
import TableHeader from "@components/TableHeader";
import { Col, Row } from "react-bootstrap";
import { Accordion } from "rsuite";
import Badge from "react-bootstrap/Badge";
import ListGroup from "react-bootstrap/ListGroup";
import Printfiled from "./Printfiled";
import { useTranslation } from "react-i18next";
const Flight = (props) => {
    
  return (
    <>
      <p className="mt-1 fw-normal">{props.t("ho_act_Opt_TarifTxt1")}</p>
      <Accordion defaultActiveKey={0} bordered className="bg-white">
        {props.prices.map((flight, flightIndex) => (
          <Accordion.Panel
            className="text-left"
            header={
              <div className="p-3">
                <span className="fs-5 fw-bold" style={{ color: "gray" }}>
                  {flight.departure_country.name} -{" "}
                  {flight.arrival_country.name}
                </span>
              </div>
            }
            eventKey={flightIndex}
          >
            <Itinerary flight={flight} {...props} />
          </Accordion.Panel>
        ))}
      </Accordion>
    </>
  );
};

export default Flight;

const Itinerary = (props) => {
  const { t } = useTranslation();
  const header = [
    {
      title: "vol",
      width: 15,
      align: "left",
    },
    {
      title: "class",
      width: 5,
      align: "center",
    },
    {
      title: "departure",
      width: 35,
      align: "left",
    },
    {
      title: "arrival",
      width: 35,
      align: "left",
    },

    {
      title: "duration",
      width: 10,
      align: "center",
    },
  ];

  const headerPrice = [
    {
      title: "base_amount",
      width: 20,
      align: "center",
      filed: "base_amount",
      filedList: ["adult", "child", "infant"],
    },
    {
      title: "charge",
      width: 20,
      align: "center",
      filed: "charge",
      filedList: ["adult", "child", "infant"],
    },
    {
      title: "amount_traveler",
      width: 20,
      align: "center",
      filed: "amount_traveler",
      filedList: ["adult", "child", "infant"],
    },
    {
      title: "you_earn",
      width: 20,
      align: "center",
      filed: "you_earn",
      filedList: ["adult", "child", "infant"],
    },
    { title: "", width: 5, align: "center", filed: "button" },
  ];
  return (
    <>
      {props.flight.itinerary.map((itinerary, itineraryIndex) => (
        <Row>
          <Col md="4">
            <ListGroup as="ol" numbered>
              <ListGroup.Item
                as="li"
                className="d-flex justify-content-between align-items-start"
              >
                <div className="ms-2 me-auto">
                  <div className="fw-bold">{props.t("trip")}</div>
                </div>
                <Badge bg="blue" className="w-30">
                  {itinerary.trip.name}
                </Badge>
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                className="d-flex justify-content-between align-items-start"
              >
                <div className="ms-2 me-auto">
                  <div className="fw-bold">{props.t("origin")}</div>
                </div>
                <Badge bg="blue" className="">
                  {itinerary.origin.name}
                </Badge>
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                className="d-flex justify-content-between align-items-start"
              >
                <div className="ms-2 me-auto">
                  <div className="fw-bold">{props.t("destination")}</div>
                </div>
                <Badge bg="blue" className="">
                  {itinerary.destination.name}
                </Badge>
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                className="d-flex justify-content-between align-items-start"
              >
                <div className="ms-2 me-auto">
                  <div className="fw-bold">{props.t("adult")}</div>
                </div>
                <Badge bg="blue" className="w-30">
                  {itinerary.adult}
                </Badge>
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                className="d-flex justify-content-between align-items-start"
              >
                <div className="ms-2 me-auto">
                  <div className="fw-bold">{props.t("child")}</div>
                </div>
                <Badge bg="blue" className="w-30">
                  {itinerary.child}
                </Badge>
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                className="d-flex justify-content-between align-items-start"
              >
                <div className="ms-2 me-auto">
                  <div className="fw-bold">{props.t("baby")}</div>
                </div>
                <Badge bg="blue" className="w-30">
                  {itinerary.infant}
                </Badge>
              </ListGroup.Item>
            </ListGroup>
          </Col>
          <Col md="8">
            <div class="tableFixHead">
              {/* <TableHeader header={headerPrice} /> */}
               <table >
              <thead>
                  <tr>
                    {headerPrice.map((item,index)=>(
                      <th key={index} className="text-start">{t(item.title)}</th>
                    ))}
                  
                  </tr>
                </thead>
             
                <tbody>
                  <tr >
                    {headerPrice.map((head) => (
                      <td
                        
                      >
                        <Printfiled
                          tarif={itinerary.pricing}
                          filed={head.filed}
                          filedList={head?.filedList}
                          onStopSales=""
                          priceForm={props.priceForm}
                          config=""
                          dataIndex={{
                            item: itinerary.pricing,
                            index: itineraryIndex,
                          }}
                        />
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>

























            </div>

            <div class="tableFixHead">
              
              <table>
                <TableHeader header={header} />
                <tbody>
                  {itinerary.segments.map((segment, segmentIndex) => (
                    <tr key={segmentIndex}>
                      <td
                        style={{
                          textAlign: header[0]["align"],
                        }}
                      >
                        {segment.flight_number}
                      </td>
                      <td
                        className="cell100"
                        style={{
                          width: header[1]["width"] + "%",
                          textAlign: header[1]["align"],
                        }}
                      >
                        {segment.class}
                      </td>
                      <td
                        className="cell100"
                        style={{
                          width: header[2]["width"] + "%",
                          textAlign: header[2]["align"],
                        }}
                      >
                        {segment.departure.name}
                        <br></br>
                        {segment.departure_at}
                        <br></br>
                        {props.t("terminal")} : {segment.departure_terminal}
                      </td>
                      <td
                        className="cell100"
                        style={{
                          width: header[3]["width"] + "%",
                          textAlign: header[3]["align"],
                        }}
                      >
                        {segment.arrival.name}
                        <br></br>
                        {segment.arrival_at}
                        <br></br>
                        {props.t("terminal")} : {segment.arrival_terminal}
                      </td>
                      <td
                        className="cell100"
                        style={{
                          width: header[4]["width"] + "%",
                          textAlign: header[4]["align"],
                        }}
                      >
                        {segment.duration}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
      ))}
    </>
  );
};
